import React, { useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

import './dropdown.css';
function Dropdown(props) {
    const [value, setValue] = useState('None');

    const handleChange = (event) => {
        setValue(event.target.value);
        props.handleChange(props.name, event.target.value);
    }

    return(
        <FormControl className='dropdown' variant='outlined'>
            <InputLabel id='input_label_filter'>{props.name}</InputLabel>
            <Select
                labelId='input_label_filter'
                id='input_filter'
                value={value}
                onChange={handleChange}
                label={props.name}
            >
                {props.availables.map((item) => {
                    return (<MenuItem key={item} value={item}>{item}</MenuItem>);
                })}
            </Select>
        </FormControl>
    )
}

export default Dropdown;